import React from 'react';
export function makeEnum(...x) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    const o = {};
    for (const item of x) {
        o[item] = item;
    }
    return o;
}
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        !Array.isArray(obj) &&
        Object.getPrototypeOf(obj) === Object.prototype);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepMerge(...objects) {
    if (objects.length === 0) {
        throw new Error('deepMerge requires at least one argument');
    }
    const target = objects[0];
    for (let i = 1; i < objects.length; i++) {
        const source = objects[i];
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                if (isObject(source[key])) {
                    if (!isObject(target[key])) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
                        target[key] = {};
                    }
                    // @ts-ignore
                    deepMerge(target[key], source[key]);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
                    target[key] = source[key];
                }
            }
        }
    }
    return target;
}
export function toArray(arrayOrElement) {
    if (arrayOrElement === null || arrayOrElement === undefined) {
        return undefined;
    }
    if (Array.isArray(arrayOrElement)) {
        return arrayOrElement;
    }
    return [arrayOrElement];
}
export function flattenChildren(children) {
    const innerChildren = React.Children.toArray(children);
    const flatten = (children) => {
        return React.Children.toArray(children).flatMap(stripFragment);
    };
    return flatten(flatten(innerChildren)).filter(Boolean);
}
function stripFragment(child) {
    if (child &&
        React.isValidElement(child) &&
        child.type === React.Fragment) {
        return child.props.children;
    }
    return child;
}
/**
 * Adds a VERSION property to a React component for Figma design sync tracking.
 *
 * @param component - The React component to version
 * @param version - Version string in format "1.0.0"
 * @returns The component with VERSION property attached
 *
 * @example
 * const ButtonComponent = React.forwardRef<HTMLButtonElement, ButtonProps>(...);
 * export const Button = withVersion(ButtonComponent, '1.0.0');
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withVersion(component, version) {
    return Object.assign(component, { VERSION: version });
}
export function reactElementSerializer(key, value) {
    if (typeof value === 'function') {
        return `[Function: ${value.name ?? 'anonymous'}]`;
    }
    if (React.isValidElement(value) && key) {
        const displayName = typeof value.type === 'string'
            ? value.type
            : value.type.displayName ||
                value.type.name ||
                'Component';
        return `<${displayName}>${JSON.stringify(value.props, reactElementSerializer)}</${displayName}>`;
    }
    return value;
}
